"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var root = function root(visible) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("opacity:", visible ? '1' : '0', ";transition:all 0.2s ease-out;box-sizing:content-box !important;> div{display:inline-block;width:100%;}")
  );
};

var _default = {
  root: root
};
exports.default = _default;